<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "statePayment",
    data(){
        return{

        }
    },
    methods:{

    },
    components:{

    },
    mounted(){

    }
}
</script>
<style rel="stylesheet" lang="scss">
    @import 'scss/style';
    @import 'scss/commom';
</style>



// WEBPACK FOOTER //
// src/statepayment/App.vue